import axios, { getJWT } from './axios';

const baseUrl = `/api/v1/user/`;

export const getReferral = async () => {
  const header = await getJWT();
  const res = await axios.get(baseUrl + 'referral', header);
  return res.data;
};
